import React from 'react'
import styles from './DocumentView.module.scss'

const STATUS_COLORS = {
  draft:     { bg: '#f1f5f9', color: '#64748b' },
  pending:   { bg: '#fef9c3', color: '#854d0e' },
  signing:   { bg: '#dbeafe', color: '#1d4ed8' },
  approved:  { bg: '#dcfce7', color: '#15803d' },
  returned:  { bg: '#fee2e2', color: '#b91c1c' },
  cancelled: { bg: '#f3f4f6', color: '#6b7280' },
}

function fmtDate(str) {
  if (!str) return '—'
  const d = new Date(str)
  if (isNaN(d.getTime())) return str
  return d.toLocaleDateString('ru-RU', { day: '2-digit', month: 'long', year: 'numeric' })
}

export default function DocHeader({ doc }) {
  const sc = STATUS_COLORS[doc.status] || STATUS_COLORS.draft

  return (
    <div className={styles.docHeader}>
      {/* Reg block */}
      <div className={styles.headerTop}>
        <div className={styles.regBlock}>
          <span className={styles.regLabel}>Регистрационный номер</span>
          <span className={styles.regNum}>{doc.reg_number}</span>
        </div>
        <span className={styles.statusBadge} style={{ background: sc.bg, color: sc.color }}>
          {doc.status_display}
        </span>
      </div>

      {/* Subject */}
      <h2 className={styles.docSubject}>{doc.subject}</h2>

      {/* Meta grid */}
      <dl className={styles.metaGrid}>
        <dt>Тип</dt>
        <dd>{doc.doc_type_display}</dd>

        <dt>Дата</dt>
        <dd>{fmtDate(doc.created_at)}</dd>

        <dt>Отправитель</dt>
        <dd>
          <strong>{doc.from_employee_name}</strong>
          {doc.from_employee_dept && (
            <span className={styles.metaSub}>{doc.from_employee_dept}</span>
          )}
        </dd>

        <dt>Получатель</dt>
        <dd>
          <strong>{doc.to_employee_name || '—'}</strong>
          {doc.to_employee_dept && (
            <span className={styles.metaSub}>{doc.to_employee_dept}</span>
          )}
        </dd>

        {doc.resolution_name && (
          <>
            <dt>Резолюция</dt>
            <dd>
              <strong>{doc.resolution_name}</strong>
              {doc.resolution_dept && (
                <span className={styles.metaSub}>{doc.resolution_dept}</span>
              )}
            </dd>
          </>
        )}

        {doc.status === 'returned' && doc.return_reason && (
          <>
            <dt>Причина возврата</dt>
            <dd className={styles.returnReason}>{doc.return_reason}</dd>
          </>
        )}
      </dl>
    </div>
  )
}
